export default __webpack_public_path__ + "static/media/joseph-kneeling.eb71c463.gif";